import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  HttpContextToken,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { TranslateLoader } from '@ngx-translate/core';
import { provideDesignAngularKit } from 'design-angular-kit';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { catchError, Observable, of } from 'rxjs';
import { LoginInterceptor } from './shared/helpers/intercept.service';
import { HttpContextConfig } from './shared/interfaces/http-context-config.model';
import { AuthService } from './shared/services/auth.service';
import { routes } from './app.routes';
import { AuthInterceptor } from './shared/helpers/auth-intercept.service';

registerLocaleData(localeIt);

export const NO_LOADER = new HttpContextToken<boolean>(() => false);
export const CONFIG = new HttpContextToken<HttpContextConfig>(() => new HttpContextConfig());

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideDesignAngularKit({
      translateLoader: (itPrefix: string, itSuffix: string) => ({
        provide: TranslateLoader,
        useFactory: (http: HttpBackend) =>
          new MultiTranslateHttpLoader(http, [
            { prefix: itPrefix, suffix: itSuffix },
            { prefix: './assets/i18n/' },
          ]),
        deps: [HttpBackend],
      }),
    }),
    { provide: LOCALE_ID, useValue: 'it-IT' },
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(initializeAppFactory()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoginInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
};

function initializeAppFactory(): () => Observable<any> {
  return () => {
    const _authService: AuthService = inject(AuthService);
    const _router: Router = inject(Router);

    if (_authService.isAuthenticated())
      return _authService.getCurrentUser().pipe(
        catchError(() => {
          localStorage.clear();
          _authService.setCurrentUser(null);
          _router.navigate(['/auth/login']);
          return of(null);
        }),
      );
    return of(null);
  };
}
